import { get, getAll } from '@bigyouth/base'

export default {
  name: 'form-register',

  componentDidMount () {
    const noticesWrapper = get('.notices', this.el)
    const mutConfig = { childList: true }

    const mutObserver = new MutationObserver(() => {
      const notices = getAll('li', noticesWrapper)

      notices.forEach((notice) => {
        const noticeContent = notice.textContent.toUpperCase()

        if (noticeContent.includes('[USED]')) {
          if (noticeContent.includes('EMAIL')) {
            // todo: Trad
            // notice.textContent = 'Email déjà utilisé.'
            notice.textContent = window.shopifyTranslations.usedEmail
          }
          if (noticeContent.includes('PHONE')) {
            // todo: Trad
            // notice.textContent = 'Numéro de téléphone déjà utilisé.'
            notice.textContent = window.shopifyTranslations.usedPhone
          }
        } else {
          notice.remove()
        }
      })
    })

    mutObserver.observe(noticesWrapper, mutConfig)
  },
}
